import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { MEMES_CONTRACT } from "@/constants/constants";
import { formatClaimCost, formatClaimStatus, formatEditionSize } from "@/helpers/manifoldDisplayHelpers";
import { useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import { useNftBalance } from "@/hooks/useNftBalance";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";
import NowMintingStatsItem from "./NowMintingStatsItem";
interface NowMintingStatsGridProps {
  readonly nftId: number;
  readonly floorPrice: string;
}
export default function NowMintingStatsGrid(t0) {
  const $ = _c(33);
  const {
    nftId,
    floorPrice
  } = t0;
  const manifoldClaim = useMemesManifoldClaim(nftId);
  const status = manifoldClaim?.status;
  const isStatusLoading = !manifoldClaim;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.consolidation_key ?? null;
  let t2;
  if ($[0] !== nftId || $[1] !== t1) {
    t2 = {
      consolidationKey: t1,
      contract: MEMES_CONTRACT,
      tokenId: nftId
    };
    $[0] = nftId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    balance,
    isLoading: isBalanceLoading
  } = useNftBalance(t2);
  let t3;
  if ($[3] !== manifoldClaim) {
    t3 = manifoldClaim ? formatClaimStatus(manifoldClaim) : undefined;
    $[3] = manifoldClaim;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const statusLabel = t3;
  const statusTone = manifoldClaim?.isFinalized ? "ended" : status;
  let t4;
  if ($[5] !== manifoldClaim) {
    t4 = manifoldClaim ? formatEditionSize(manifoldClaim).replace(/\s*\/\s*/, "/") : undefined;
    $[5] = manifoldClaim;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const editionSize = t4;
  let t5;
  if ($[7] !== manifoldClaim) {
    t5 = manifoldClaim ? formatClaimCost(manifoldClaim) : undefined;
    $[7] = manifoldClaim;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const mintPrice = t5;
  const balanceTooltip = balance > 0 ? `SEIZED x${balance}` : "UNSEIZED";
  const showBalance = connectedProfile && !isBalanceLoading;
  let t6;
  if ($[9] !== balance || $[10] !== balanceTooltip || $[11] !== nftId || $[12] !== showBalance) {
    t6 = showBalance && <><span data-tooltip-id={`balance-tooltip-${nftId}`} className="tw-flex tw-cursor-pointer tw-items-center tw-gap-1 tw-rounded tw-bg-iron-800 tw-p-1.5 tw-font-sans tw-leading-none"><FontAwesomeIcon icon={faLayerGroup} className="tw-size-3 tw-text-iron-400" /><span className="tw-text-[12px] tw-font-medium tw-text-iron-300">{balance}</span></span><Tooltip id={`balance-tooltip-${nftId}`} content={balanceTooltip} place="top" border="1px solid rgba(255, 255, 255, 0.15)" style={{
        backgroundColor: "#26272B",
        color: "white",
        padding: "6px 10px",
        fontSize: "12px",
        fontWeight: 600,
        borderRadius: "6px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)"
      }} /></>;
    $[9] = balance;
    $[10] = balanceTooltip;
    $[11] = nftId;
    $[12] = showBalance;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== editionSize || $[15] !== t6) {
    t7 = <span className="tw-flex tw-items-center tw-gap-2">{editionSize}{t6}</span>;
    $[14] = editionSize;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const editionValue = t7;
  let t8;
  if ($[17] !== editionValue) {
    t8 = <NowMintingStatsItem label="Edition" value={editionValue} />;
    $[17] = editionValue;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isStatusLoading || $[20] !== statusLabel || $[21] !== statusTone) {
    t9 = <NowMintingStatsItem label="Status" value={statusLabel} status={statusTone} isLoading={isStatusLoading} />;
    $[19] = isStatusLoading;
    $[20] = statusLabel;
    $[21] = statusTone;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isStatusLoading || $[24] !== mintPrice) {
    t10 = <NowMintingStatsItem label="Mint price" value={mintPrice} isLoading={isStatusLoading} />;
    $[23] = isStatusLoading;
    $[24] = mintPrice;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== floorPrice) {
    t11 = <NowMintingStatsItem label="Floor" value={floorPrice} />;
    $[26] = floorPrice;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t8 || $[31] !== t9) {
    t12 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-pt-4">{t8}{t9}{t10}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t8;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
}